/* eslint-disable */
import studyPlan from '@/store/study-plan/sagas';
import users from '@/store/users/sagas';
import { all } from 'redux-saga/effects';

export function* rootSaga() {
  yield all([...studyPlan, ...users]);
}
